<template>
  <div class="section">
    <h3 class="mt-4">
      タイムライン
    </h3>
    <table class="table table-striped table-bordered timeline-table">
      <thead>
        <tr>
          <th scope="col" class="timeline-head-col">日時</th>
          <th scope="col"
              v-for="ch in characters"
              :key="ch.id"
              @dblclick="openModal(ch)">
            {{ ch.name }}
            <span class="text-muted">
              <font-awesome-icon icon="calendar-plus" @click="openModal(ch)"/>
            </span>
          </th>
        </tr>
      </thead>
      <draggable tag="tbody" :list="list" :value="value" @input="emitter">
        <tr v-for="row in realValue" :key="row.id">
          <th scope="row" class="timeline-head-col">{{ row.key }}</th>
          <td v-for="ch in characters" :key="ch.id" @dblclick="openModal(ch, row)">
            <MarkdownView :text="row.characters[ch.id] ? row.characters[ch.id].text : ''" />
          </td>
        </tr>
      </draggable>
    </table>
    <b-modal :id="uid('modal')"
             centered size="xl"
             :title="characterName"
             @shown="modalShown"
             @ok="modalSave">
      <div class="form-group">
        <label :for="uid('modal-datetime')">日時</label>
        <input type="text"
               :disabled="!!id"
               :list="uid('modal-datetime-list')"
               class="form-control"
               :id="uid('modal-datetime')"
               ref="modalDatetime"
               v-model="key" />
        <datalist :id="uid('modal-datetime-list')">
          <option v-for="row in realValue" :key="row.id" :value="row.key" />
        </datalist>
      </div>
      <div class="form-group">
        <label for="uid('modal-text')">情報</label>
        <textarea class="form-control"
                  :id="uid('modal-text')"
                  ref="modalText"
                  rows="30"
                  v-model="text"
                  @keypress="modalKeyPress">
        </textarea>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import MarkdownView from '@/components/MarkdownView.vue'

export default {
  name: 'Timeline',

  components: {
    draggable,
    MarkdownView
  },

  data(){
    return {
      id: '',
      key: '',
      character: '',
      characterName: '',
      text: ''
    }
  },

  methods: {
    emitter(value){
      const normalized = []
      value.forEach(row => {
        let empty = true
        Object.keys(row.characters).forEach(k => {
          const ch = row.characters[k]
          if(ch.text){ empty = false }
        })
        if(!empty){ normalized.push(row) }
      })
      this.$emit('input', normalized)
    },

    uid(prefix){
      return prefix + '-' + this._uid
    },

    generateKey(){
      const value = this.value || this.list
      const keys = new Set(value.map(v => v.key))
      let index = 1, str = '00001'
      while(keys.has(str)){
        ++index
        str = '0000' + index
        str = str.substring(str.length - 5)
      }
      return str
    },

    openModal(ch, row){
      if(row){
        this.id   = row.id
        this.key  = row.key
        this.text = row.characters[ch.id] ? row.characters[ch.id].text : ''
      }else{
        this.id   = ''
        this.key  = ''
        this.text = ''
      }
      this.character = ch.id
      this.characterName = ch.name
      this.$bvModal.show(this.uid('modal'))
    },

    modalShown(){
      if(this.key){
        this.$refs.modalText.focus()
      }else{
        this.$refs.modalDatetime.focus()
      }
    },

    modalKeyPress(e){
      if(e.ctrlKey && e.keyCode == 10){ this.modalSubmit() }
    },

    modalSubmit(){
      this.modalSave()
      this.$bvModal.hide(this.uid('modal'))
    },

    modalSave(){
      const value = this.value || this.list
      let obj = value.find(r => r.id == this.id)
      if(!obj){ obj = value.find(r => r.key == this.key) }
      if(!obj){
        obj = {
          key: this.key || this.generateKey(),
          characters: {}
        }
        obj.characters[this.character] = {
          text: this.text
        }
        value.push(obj)
      }else{
        if(!obj.characters[this.character]){
          this.$set(obj.characters, this.character, {})
        }
        obj.characters[this.character].text = this.text
      }
      this.emitter(value)
    }
  },

  computed: {
    realValue(){
      return this.value || this.list
    },
  },

  props: {
    value: {
      required: false,
      type: Array,
      default: null
    },
    list: {
      required: false,
      type: Array,
      default: null
    },
    characters: {
      retuired: false,
      type: Array,
      default: null
    }
  }
}
</script>

<style scoped>
.timeline-table {
  table-layout: fixed;
}

.timeline-head-col {
  width: 150px;
  text-align: center;
}
</style>
